import axios from 'axios';

export default class ProjectsService {
  async getHiddenItems(projectId, pageId) {
    const response = await axios({
      method: 'get',
      url: `projects/${projectId}/display/${pageId}/hidden`,
      withCredentials: true,
    }).catch((error) => {
      console.log('getHiddenItems', error);
      throw error;
    });
    return response;
  }

  async setItemVisibility(projectId, pageId, itemId, visibility) {
    const response = await axios({
      method: 'put',
      url: `projects/${projectId}/display/${pageId}/hidden/${itemId}`,
      withCredentials: true,
      data: {
        isVisible: visibility,
      },
    }).catch((error) => {
      console.log('setItemVisibility', error);
      throw error;
    });
    return response;
  }

  async updateCategoryOrder(projectId, categoryId, itemIds) {
    const response = await axios({
      method: 'put',
      url: `projects/${projectId}/display/order`,
      withCredentials: true,
      data: {
        type: 'cashflow',
        categoryId: String(categoryId),
        orderedItems: itemIds,
      },
    }).catch((error) => {
      console.log('updateCategoryOrder', error);
      throw error;
    });
    return response;
  }

  async getTableData(url, data, method) {
    const response = await axios({
      method,
      url,
      withCredentials: true,
      data,
    }).catch((error) => {
      console.log('getTableData', error);
      throw error;
    });
    return response;
  }

  async getListOfProjects() {
    return await axios({
      method: 'get',
      withCredentials: true,
      url: '/projects',
    }).catch((error) => {
      console.log('getListOfProjects', error);
      throw error;
    });
  }

  async getEmployeesToProject(projectId) {
    const url = `projects/${projectId}/employees`;
    return await axios({
      method: 'get',
      withCredentials: true,
      url,
    }).catch((error) => {
      console.log('getEmployeesToProject', error);
      throw error;
    });
  }

  async createNewProject(data) {
    return await axios({
      method: 'post',
      withCredentials: true,
      url: '/projects',
      data,
    }).catch((error) => {
      console.log('createNewProject', error);
      throw error;
    });
  }

  async updateProject(projectId, data) {
    const url = `projects/${projectId}`;
    return await axios({
      method: 'put',
      withCredentials: true,
      url: url,
      data,
    }).catch((error) => {
      console.log('updateProject', error);
      throw error;
    });
  }

  async deleteProject(projectId) {
    const url = `projects/${projectId}`;
    return await axios({
      method: 'delete',
      url,
      withCredentials: true,
    }).catch((error) => {
      console.log('deleteProject', error);
      throw error;
    });
  }

  async getVatOptions(projectId) {
    const url = `projects/${projectId}/vat`;
    return await axios({
      method: 'get',
      withCredentials: true,
      url,
    }).catch((error) => {
      console.log('getVatOptions', error);
      throw error;
    });
  }

  async addVatOption(projectId, value) {
    const url = `projects/${projectId}/vat`;
    return await axios({
      method: 'post',
      withCredentials: true,
      url,
      data: {
        value: value,
      },
    }).catch((error) => {
      console.log('addVatOption', error);
      throw error;
    });
  }

  async deleteVatOption(projectId, vatOptionId) {
    const url = `projects/${projectId}/vat/${vatOptionId}`;
    return await axios({
      method: 'delete',
      withCredentials: true,
      url,
    }).catch((error) => {
      console.log('deleteVatOption', error);
      throw error;
    });
  }

  async updateVatReality(projectId, columnId, value, formula) {
    const url = `projects/${projectId}/vatReality`;
    return await axios({
      url,
      method: 'put',
      withCredentials: true,
      data: {
        columnId,
        value,
        formula,
      },
    }).catch((error) => {
      console.log('updateVatReality', error);
      throw error;
    });
  }
}
